import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Box, Button, Container, Typography } from '@mui/material'
import useMediaQuery from '@mui/material/useMediaQuery'
import { useTheme } from '@mui/material/styles'

const NotFound = () => {
	const { t } = useTranslation(['pages'])
	const theme = useTheme()
	const mobileDevice = useMediaQuery(theme.breakpoints.down('md'))

	return (
		<>
			<Helmet>
				<title>{t('NotFound.pageTitle')}</title>
			</Helmet>
			<Box
				sx={{
					alignItems: 'center',
					backgroundColor: 'background.paper',
					display: 'flex',
					minHeight: '100%',
					px: 3,
					py: '80px'
				}}
			>
				<Container maxWidth="lg">
					<Typography align="center" color="textPrimary" variant={mobileDevice ? 'h4' : 'h1'}>
						{t('NotFound.title')}
					</Typography>
					<Typography align="center" color="textSecondary" sx={{ mt: 0.5 }} variant="subtitle2">
						{t('NotFound.subtitle')}
					</Typography>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							mt: 6
						}}
					>
						<Box
							alt="Under development"
							component="img"
							src={`/static/error/error404_${theme.palette.mode}.svg`}
							sx={{
								height: 'auto',
								maxWidth: '100%',
								width: 400
							}}
						/>
					</Box>
					<Box
						sx={{
							display: 'flex',
							justifyContent: 'center',
							mt: 6
						}}
					>
						<Button
							color="primary"
							component={RouterLink}
							to="/"
							variant="outlined"
							data-cy="back-to-home-button"
						>
							{t('common:buttons.backToHome')}
						</Button>
					</Box>
				</Container>
			</Box>
		</>
	)
}

export default NotFound
